import routes from "../../../engine/routes";
import React from "react";
import { useParams } from "react-router-dom";
import { RenderMenuSider } from "../../../engine/AuthRoute/navigationHelper";
import { useSelector } from "react-redux";
import { renderUserName } from "../../../utils/constants";

export const InterpretesSlider = () => {
  const { id } = useParams();

  const { interprete } = useSelector(state => state.interprete);

  const prestationDetailMenu = {
    title:
      id === "new"
        ? routes.interpretes().new.title
        : renderUserName(interprete),
    root: routes.interpretes,
    children: [
      routes.interpretes(id).detail,
      routes.interpretes(id).detailSchedule,
    ],
  };

  return <RenderMenuSider menu={prestationDetailMenu} />;
};
